import {
  FieldFunctionOptions,
  FieldMergeFunction,
  InMemoryCacheConfig,
} from '@apollo/client';
import {
  QuerySearchVesselArgs,
  SearchVesselResult,
} from '../../../generated/gql';

export const vesselPaginationMerger = (
  oldValue: SearchVesselResult | undefined,
  newValue: SearchVesselResult,
  options: FieldFunctionOptions<QuerySearchVesselArgs>,
) => {
  if (!options.args?.lastPageToken) return newValue;

  let vessels = [...(oldValue?.vessels || [])];
  if (newValue.lastPageToken?.vesselId !== oldValue?.lastPageToken?.vesselId) {
    vessels = vessels.concat([...(newValue.vessels || [])]);
  }

  return { ...newValue, vessels };
};

export const refVesselCacheConfig: InMemoryCacheConfig = {
  typePolicies: {
    Query: {
      fields: {
        searchVessel: {
          keyArgs: ['query'],
          merge: vesselPaginationMerger as FieldMergeFunction<any, any>,
        },
      },
    },
  },
};
